import {COVERGO_ASIA_QA } from "../consts.js"


export const pentest_blaze = {
	"pentest-blaze-studio.qa.asia.covergo.cloud": {
		appConfig: {
			tenantId: "pentest_blaze",
			appId: "admin_portal",
		},
		envConfig: COVERGO_ASIA_QA,
		fileSystem: {
			bucketName: "covergo-apse1-qa-pentest-blaze-qa"
		}
	},
}